<template>
    <div>
        <input :disabled="disabled" type="text" style="text-align:center" v-mask="'##/##/####'" v-model="endDate" @keyup.enter="save" @blur="save">
    </div>
</template>

<script>
import { updateAds } from '../../services/ads'
    export default {
        props: ["item"],
        data: ()=>({
            endDate: '',
            disabled: false
        }),
        mounted(){
            this.endDate = new Date(this.item.endDate).toLocaleDateString()
        },
        methods:{
            async save(){
                if(this.endDate.length != 10){
                    this.$store.commit('failed', 'Data de finalização para o anúncio não foi alterada porque você digitou um formato incorreto, formato aceito: '+new Date(this.item.endDate).toLocaleDateString()+' !')
                    return this.endDate = new Date(this.item.endDate).toLocaleDateString()
                }
                if(this.endDate != new Date(this.item.endDate).toLocaleDateString()){
                    this.disabled = true
                   this.$nextTick(()=> this.disabled = false)
                    const date = new Date(this.endDate.split('/').reverse().join('-')+'T03:00:00.0000Z').toJSON()
                    if(!date){
                        return this.$store.commit('failed', 'Valor passado incorreto')
                    }
                    this.item.endDate = date
                    this.$store.commit("setLoading", true)
                    await updateAds([this.item]).then(()=>this.$store.commit('success', 'Alterado com sucesso')).catch(err => this.$store.commit('failed', err))
                    this.$store.commit("setLoading", false)
                }
            }
        }
    }
</script>
